var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lock-button-component-container",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_c('icon',{attrs:{"name":"lock","variant":"516173"}}),_vm._v(" "),_c('span',[_vm._v("UNLOCK")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }